<div class="mb-6 overflow-hidden rounded-sm bg-red-400 p-8">
  <p class="font-normal">
    <ng-content></ng-content>
  </p>
</div>
